import { type JSX } from 'react';

/**
 * Inline SVG info icon. Uses inline SVG instead of the design system's <Icon>
 * component to avoid the Skeleton layout-shift on first render.
 */
function InfoCircleIcon(): JSX.Element {
    return (
        <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="shrink-0"
            data-testid="icon-info"
            aria-hidden="true"
        >
            <path
                d="M9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39759 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39759 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333Z"
                stroke="#737E8C"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 6.66663V9.99996"
                stroke="#737E8C"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 13.3334H10.0083"
                stroke="#737E8C"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

interface RateLimitMessageProps {
    resetsAt: Date;
}

/**
 * Informational message shown in the chat thread when the user hits
 * the conversational search rate limit. Displays the absolute reset time
 * in the browser's local timezone.
 */
export function RateLimitMessage({ resetsAt }: RateLimitMessageProps): JSX.Element {
    const formattedTime = resetsAt.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

    return (
        <div className="mb-2 max-w-[90%] rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
            <div className="flex items-start gap-2">
                <InfoCircleIcon />
                <div className="text-sm text-gray-700">
                    <p>You&apos;ve hit your limit for Conversational Search messages.</p>
                    <p>Limits will reset at {formattedTime}.</p>
                </div>
            </div>
        </div>
    );
}
